import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
} from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import { v4 as uuid } from 'uuid'
import { useEnv } from '@praxis/component-runtime-env'
import { envConfigs, ReactAppEnv } from 'apiConfig'

const gqlUrl = '/api/plm_graphql'
const getAuthMiddleware = (xApiKey: string) =>
  new ApolloLink((operation, forward) => {
    return setupMiddleware(operation, forward, xApiKey)
  })

export const setupMiddleware = (
  operation: ApolloLink.Operation,
  forward: ApolloLink.ForwardFunction,
  xApiKey: string,
) => {
  const sparkUser = JSON.parse(localStorage.getItem('userLoginState') || '{}')
  const uri = `${gqlUrl}?q=${operation.operationName}`
  operation.setContext({
    uri,
    withCredentials: true,
    headers: {
      'X-Api-Id': uuid(),
      'X-Api-Key': xApiKey,
      Authorization: sparkUser?.accessToken
        ? `Bearer ${sparkUser.accessToken}`
        : '',
      'X-AUTH-TOKEN': sparkUser?.userProfileToken
        ? sparkUser.userProfileToken
        : '',
    },
  })

  return forward(operation)
}

const getClient = (xApiKey: string) =>
  new ApolloClient({
    link: getAuthMiddleware(xApiKey).concat(
      new HttpLink({ uri: gqlUrl, credentials: 'same-origin' }),
    ),
    cache: new InMemoryCache(),
  })

const PLMFederatedApolloProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const { environment }: { environment: ReactAppEnv } = useEnv()
  const client = envConfigs[environment].xApiKey
    ? getClient(envConfigs[environment].xApiKey)
    : null
  return client ? (
    <ApolloProvider client={client}>{children}</ApolloProvider>
  ) : null
}

export default PLMFederatedApolloProvider
